const divFormActions = {
  fileError: 'Aguarde todos os arquivos subirem'
};

export default divFormActions;
